import type { MailboxInfo } from 'owa-client-types';
import { OKRCategories } from './types/OKRCategories';
import { logCoreUsage } from 'owa-analytics';

type PrioritizeTelemetryEvent =
    | 'OpenInbox'
    | 'OpenSort'
    | 'OpenFilter'
    | 'EnabledChanged'
    | 'RulesCountChanged'
    | 'SummaryCardExpanded'
    | 'SummaryCardContentCopied'
    | 'PrioritizeSummary_Clicked'
    | 'EmailLabelCorrection'
    | 'PrioritizeButtonRendered'
    | 'PrioritizeViewOpened'
    | 'PrioritizeTriggered'
    | 'PrioritizeNudgeRendered'
    | 'PrioritizeNudgeDismissed';

type PrioritizeTelemetryEntryPoint = 'MessageList' | 'Settings' | 'ReadingPane';

function getOKRCategoryForEvent(event: PrioritizeTelemetryEvent): OKRCategories {
    switch (event) {
        case 'OpenInbox':
        case 'OpenSort':
        case 'OpenFilter':
        case 'PrioritizeButtonRendered':
        case 'PrioritizeNudgeRendered':
            return OKRCategories.Seen;
        case 'EnabledChanged':
        case 'RulesCountChanged':
        case 'SummaryCardExpanded':
        case 'PrioritizeSummary_Clicked':
        case 'EmailLabelCorrection':
        case 'PrioritizeViewOpened':
        case 'PrioritizeTriggered':
            return OKRCategories.Tried;
        case 'SummaryCardContentCopied':
            return OKRCategories.Kept;
        case 'PrioritizeNudgeDismissed':
        default:
            return OKRCategories.None;
    }
}

function getEntryPointForEvent(
    event: PrioritizeTelemetryEvent
): PrioritizeTelemetryEntryPoint | undefined {
    switch (event) {
        case 'OpenInbox':
        case 'OpenSort':
        case 'OpenFilter':
        case 'PrioritizeButtonRendered':
        case 'PrioritizeViewOpened':
        case 'PrioritizeTriggered':
        case 'PrioritizeNudgeRendered':
        case 'PrioritizeNudgeDismissed':
            return 'MessageList';
        case 'EnabledChanged':
        case 'RulesCountChanged':
            return 'Settings';
        case 'SummaryCardExpanded':
        case 'SummaryCardContentCopied':
        case 'PrioritizeSummary_Clicked':
        case 'EmailLabelCorrection':
            return 'ReadingPane';
        default:
            return undefined;
    }
}

export function logPrioritizeTelemetryEvent(
    event: PrioritizeTelemetryEvent,
    mailboxInfo: MailboxInfo,
    customData: {
        [key: string]: any;
    } = {}
): void {
    logCoreUsage('AIStandardTelemetry', mailboxInfo, {
        CopilotEventName: event,
        OKRCategory: getOKRCategoryForEvent(event),
        EntryPoint: getEntryPointForEvent(event),
        Action: 'Other',
        Scenario: 'Prioritize',
        ...customData,
    });
}
